import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sensor-map-line-component',
  templateUrl: './sensor-map-line-component.page.html',
  styleUrls: ['./sensor-map-line-component.page.css'],
})
export class SensorMapLineComponentPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
